import { useGoldConfig } from '@iheartjane/data-access/react-query';
import { useShouldShowGold as useShouldShowGoldMenu } from '@iheartjane/menu';

import { useSafeEcommApp } from '@jane/shared/providers';

export interface ShouldShowGoldProps {
  store?: {
    id?: string | number;
    state?: string | null;
  };
}

/** @todo consider applying useShouldShowGoldMenu from '@iheartjane/menu' directly */
export const useShouldShowGold = (props?: ShouldShowGoldProps): boolean => {
  const { appMode } = useSafeEcommApp();
  const { data: goldConfig, isLoading: isLoadingGoldConfig } = useGoldConfig();

  return (
    useShouldShowGoldMenu({
      appMode,
      goldConfig,
      state: props?.store?.state,
      storeId: props?.store?.id,
    }) && !isLoadingGoldConfig
  );
};
